import {create} from 'zustand';
import {User} from "/types/user-type";
import {persist} from "zustand/middleware";
import {ROLES} from "../../../constant/roles";

export interface CurrentUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  profileImageUrl?: string;
  phoneNumber?: string | null;
  country?: string;
}

interface CommonStoreState {
  user: CurrentUser | null;
  isAdmin: boolean;
  isOrgAdmin: boolean;
  isSuperAdmin: boolean;
  isOnlyOrgUser: boolean;
  isAppUser: boolean;
  isOnlyAppUser: boolean;
  setUser: (user: User | null) => void;
  reset: () => void;
}

export const useCommonStore = create<CommonStoreState>()(
  persist(
    (set) => ({
      user: null,
      isAdmin: false,
      isOrgAdmin: false,
      isSuperAdmin: false,
      isOnlyOrgUser: false,
      isAppUser: false,
      isOnlyAppUser: false,
      setUser: (user) => {
        if (!user) {
          set({ user: null, isAdmin: false, isOrgAdmin: false, isSuperAdmin: false });
          return;
        }
        
        set({
          user: {
            id: user.itemId,
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            profileImageUrl: user.profileImageUrl,
            phoneNumber: user.phoneNumber,
            country: user.country,
          },
          isAdmin: user.roles.includes(ROLES.ADMIN),
          isOrgAdmin: user.roles.includes(ROLES.ORG_ADMIN),
          isSuperAdmin: user.roles.includes(ROLES.SUPER_ADMIN),
          isOnlyOrgUser: user.roles.includes(ROLES.ORG_USER) && !user.roles.includes(ROLES.ORG_ADMIN),
          isAppUser: user.roles.includes(ROLES.USER),
          isOnlyAppUser: user.roles.length === 1 && user.roles.includes(ROLES.USER)
        });
      },
      reset: () => {
        set({
          user: null,
          isAdmin: false,
          isOrgAdmin: false,
          isSuperAdmin: false,
          isOnlyOrgUser: false,
          isAppUser: false,
          isOnlyAppUser: false,
        });
      },
    }),
    {name: 'user-storage'}
  )
);
